let tail: Promise<void> = Promise.resolve();

export function queueAttachUpload<T>(run: () => Promise<T>, signal?: AbortSignal): Promise<T> {
  const aborted = () => new DOMException("Upload aborted", "AbortError");
  if (signal?.aborted) return Promise.reject(aborted());
  let cancel: (() => void) | undefined;
  const result = new Promise<T>((resolve, reject) => {
    cancel = () => reject(aborted());
    signal?.addEventListener("abort", cancel, { once: true });
    const work = tail.then(async () => {
      if (signal?.aborted) throw aborted();
      return run();
    });
    tail = work.then(() => undefined, () => undefined);
    work.then(resolve, reject);
  });
  return result.finally(() => {
    if (cancel) signal?.removeEventListener("abort", cancel);
  });
}
